import { Component } from 'react';
import { AssetLoaderContextProps, WithAssetLoader } from './types';

export const withAssetLoader =
    (Context: React.Context<AssetLoaderContextProps>): WithAssetLoader =>
    <T,>(WrappedComponent: React.ComponentType<T & AssetLoaderContextProps>): React.ComponentType<T> => {
        const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

        return class ComponentWithAssetLoader extends Component<T> {
            public static displayName = `withAssetLoader(${displayName})`;

            public render() {
                return (
                    <Context.Consumer>
                        {(assetLoaderProps: AssetLoaderContextProps) => (
                            <WrappedComponent {...assetLoaderProps} {...(this.props as T)} />
                        )}
                    </Context.Consumer>
                );
            }
        };
    };
